import { render, staticRenderFns } from "./CTNotReading.AU.2.vue?vue&type=template&id=6ef1ae24&scoped=true"
import script from "./CTNotReading.AU.2.vue?vue&type=script&lang=js"
export * from "./CTNotReading.AU.2.vue?vue&type=script&lang=js"
import style0 from "./CTNotReading.AU.2.vue?vue&type=style&index=0&id=6ef1ae24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1ae24",
  null
  
)

export default component.exports